import { Base } from "./productTile.base";

export const ProductTile = Object.assign(Base, {});
